import Vue from "vue";

import UserLogin from "./User-Login.vue";

export function load(store) {
    const selector = "user-login";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    store,
    beforeCreate() {
      this.$store.commit('initialiseStore');
    },
    render: createElement =>
      createElement(UserLogin, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
